import {
  Component,
  OnInit,
  HostBinding,
  Input
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'scw-shards-access',
  templateUrl: './access.component.pug',
  styleUrls: ['./access.component.less'],
  host: {
    '[class.--access-granted]': 'granted || null',
  },
  providers: []
})
export class SCWShardsAccessComponent {
  private _hint: SafeHtml = '';
  @Input() set hint(hint: SafeHtml) {
    this._hint = this._sanitizer.bypassSecurityTrustHtml(hint as string);
  }
  get hint(): SafeHtml {
    return this._hint;
  }

  @Input() granted: boolean = false;

  constructor(
    private _sanitizer: DomSanitizer,
  ) {
    // Noop.
  }
}
